import { render, staticRenderFns } from "./RatingStars.vue?vue&type=template&id=044bb550&"
import script from "./RatingStars.vue?vue&type=script&lang=js&"
export * from "./RatingStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports